import React from 'react'
import { StateTaxFields } from 'discada/dist/Form/StateFeeTaxAutoForm'
import Button from 'discada/dist/Button'
import { Switch } from 'discada/dist/Form'

import StateFeeTaxForm from 'components/forms/StateFeeTaxForm'

import Loading from 'discada/dist/Loading'
import { changeQuote } from 'actions/quoteActions'
import { getQuoteValue } from 'selectors/quoteSelectors'
import { GET } from 'actions/apiActions'
import { connect } from 'react-redux'

import { FeesTweak } from 'components/Quote/DealWorkArea'
import { getHasMdrive } from 'selectors/appStatusSelectors'

export class StateFeeTaxAutoFormModal extends StateFeeTaxForm {
  static getDerivedStateFromProps(newProps, oldState) {
    return {
      ...oldState,
      customerZipCode: newProps.customerZipCode,
      includeFees: oldState.manual
        ? oldState.includeFees
        : newProps.includeFees,
      includeTaxes: oldState.manual
        ? oldState.includeTaxes
        : newProps.includeTaxes,
    }
  }

  render() {
    let {
        pending,
        formSchema,
        taxRegionId,
        stateFeeTax,
        includeTaxes,
        includeFees,
        customerZipCode,
      } = this.state,
      onSubmit = () => {
        const { vehicleId, quoteId, changeQuote, onClose } = this.props,
          { stateFeeTax, taxRegionId, includeTaxes, includeFees } = this.state

        changeQuote(
          vehicleId,
          quoteId,
          { taxRegionId, stateFeeTax, includeTaxes, includeFees },
          { forceProgramUpdate: true },
        )

        onClose()
      },
      { size, usingMdrive } = this.props,
      fieldProps = {
        size,
      }

    return (
      <div className="state-fee-tax-form">
        <h4>Tax &amp; Fee Options for {customerZipCode}</h4>
        {pending ? (
          <Loading />
        ) : (
          <React.Fragment>
            <Switch
              {...fieldProps}
              success
              rounded
              value={includeTaxes}
              label="Include Taxes in Quote"
              onChange={() =>
                this.setState({
                  includeTaxes: !this.state.includeTaxes,
                  manual: true,
                })
              }
            />
            {includeTaxes && (
              <React.Fragment>
                {this.getRegionSelectField(true)}
                {taxRegionId && (
                  <StateTaxFields
                    {...fieldProps}
                    fieldSize="small"
                    onChange={this.inputChangeFn}
                    fields={formSchema.properties}
                    values={stateFeeTax}
                  />
                )}
              </React.Fragment>
            )}

            <hr />
            <Switch
              {...fieldProps}
              success
              rounded
              value={includeFees}
              label="Include Fees in Quote"
              onChange={() =>
                this.setState({
                  includeFees: !this.state.includeFees,
                  manual: true,
                })
              }
            />
            {includeFees && !usingMdrive && (
              <FeesTweak {...fieldProps} {...this.props} />
            )}
            <hr />

            <Button {...fieldProps} success onClick={onSubmit}>
              Apply
            </Button>
            <Button {...fieldProps} text onClick={this.props.onClose}>
              Cancel
            </Button>
          </React.Fragment>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, op) => {
  const gqv = key => getQuoteValue(state, op.vehicleId, op.quoteId, key),
    zip = gqv('customerZipCode'),
    taxRegionId = gqv('taxRegionId'),
    stateFeeTax = gqv('stateFeeTax')

  return {
    ...op,
    taxRegionId,
    zip,
    stateFeeTax,
    customerZipCode: zip,
    includeFees: getQuoteValue(state, op.vehicleId, op.quoteId, 'includeFees'),
    usingMdrive: getHasMdrive(state),
    includeTaxes: getQuoteValue(
      state,
      op.vehicleId,
      op.quoteId,
      'includeTaxes',
    ),
  }
}

export default connect(
  mapStateToProps,
  {
    changeQuote,
    taxFeeOptionsByZip: GET.taxFeeOptionsByZip,
  },
)(StateFeeTaxAutoFormModal)
